import { SelectableBox } from '@/components/ui/selectable-box'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { cn } from '@/lib/utils'
import type { Control } from 'react-hook-form'
import type { FormValues } from './agent-detail.schema'
import { Checkbox } from '@/components/ui/checkbox'
import { VOICE_OPTIONS } from './agent-detail.constants'

type VoiceCardContentProps = {
  control: Control<FormValues>
}

/** Voice settings content (no Card wrapper) — used inside ChannelSettingsCard tabs */
export function VoiceCardContent({ control }: VoiceCardContentProps) {
  return (
    <div className="space-y-6">
      <FormField
        control={control}
        name="voiceModelId"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Voice</FormLabel>
            <FormControl>
              <div className="flex flex-wrap gap-2">
                {VOICE_OPTIONS.map(option => (
                  <SelectableBox
                    key={option.id}
                    id={option.id}
                    selected={field.value === option.id}
                    onSelect={id => field.onChange(id)}
                  >
                    <div className="space-y-0.5">
                      <div className="font-medium">{option.label}</div>
                      <div
                        className={cn(
                          'text-xs',
                          field.value === option.id
                            ? 'text-white/80'
                            : 'text-muted-foreground',
                        )}
                      >
                        {option.description}
                      </div>
                    </div>
                  </SelectableBox>
                ))}
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="enableTypingInBackground"
        render={({ field }) => (
          <FormItem>
            <div className="flex items-start gap-2">
              <div className="flex h-full items-center justify-center">
                <FormControl>
                  <Checkbox
                    className="mt-0.5"
                    checked={field.value ?? false}
                    onCheckedChange={checked =>
                      field.onChange(checked === true)
                    }
                  />
                </FormControl>
              </div>
              <div className="space-y-1">
                <FormLabel className="font-medium">
                  Enable typing in background
                </FormLabel>
                <FormDescription>
                  Play typing sounds as the agent is composing a response
                </FormDescription>
              </div>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}
